import { Injectable } from '@angular/core';
import { BackgroundImage } from '@models/background-image';

@Injectable({
  providedIn: 'root',
})
export class SeasonBackgroudDataService {
  /**
   * @description
   *
   * winter:  12/21/22 to 03/19/2023
   * Spring: 3/20/23 === 3/20/23 to 6/20/23
   * Summer: 6/21/23 === 6/21/23 to 9/22/23
   * Fall: 9/23/23 === 9/23/23 to 12/20/23
   */
  isWinter(day, month) {
    return month < 3 || (month === 3 && day <= 19) || (month === 12 && day >= 21);
  }
  isSpring(day, month) {
    return month < 6 || (month === 6 && day <= 20) || (month === 3 && day >= 20);
  }
  isSummer(day, month) {
    return month < 9 || (month === 9 && day <= 22) || (month === 6 && day >= 21);
  }
  public getSeasonBackgroundImg(): BackgroundImage {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    if (this.isWinter(day, month)) {
      return {
        acmic: '/assets/img/images/AAA-Insurance-Winter_o.jpg',
        ma: '/assets/img/images/winter-ma.jpg',
      };
    } else if (this.isSpring(day, month)) {
      return {
        acmic: '/assets/img/images/AAA-Insurance-Spring_o.jpg',
        ma: '/assets/img/images/spring-ma.jpg',
      };
    } else if (this.isSummer(day, month)) {
      return {
        acmic: '/assets/img/images/AAA-Insurance-Summer_o.jpg',
        ma: '/assets/img/images/summer-ma.jpg',
      };
    } else {
      return {
        acmic: '/assets/img/images/acmic-new-fall-min.jpg',
        ma: '/assets/img/images/autumn-ma.jpg',
      };
    }
  }
}
